import controller from './logout.controller';

const LogoutComponent = {
  controller,
};

export default LogoutComponent;



// WEBPACK FOOTER //
// ./client/app/logout/logout.component.js